import { ArrowUp, ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";
import { SERVICES } from "@/config/content";
import { getEmailLink, getWhatsAppLink, SITE } from "@/config/site";

const navigation = [
  { label: "Início", to: "/" },
  { label: "Serviços", to: "/servicos" },
  { label: "Sobre", to: "/sobre" },
  { label: "Contato", to: "/contato" },
];

export const Footer = () => (
  <footer data-header-theme="dark" className="bg-[#050606] text-white" data-testid="site-footer">
    <div className="site-shell">
      <div className="flex flex-col gap-5 border-b border-white/10 py-6 text-[10px] font-bold uppercase tracking-[.18em] text-white/38 sm:flex-row sm:items-center sm:justify-between">
        <p className="flex items-center gap-3"><span className="h-2 w-2 bg-lime-300" />Estratégia, design e engenharia</p>
        <Link to="/contato" className="group inline-flex w-fit items-center gap-3 text-white transition-colors hover:text-lime-300">
          Iniciar um projeto
          <ArrowUpRight className="transition-transform group-hover:-translate-y-0.5 group-hover:translate-x-0.5" size={15} />
        </Link>
      </div>

      <div className="grid gap-14 border-b border-white/10 py-16 lg:grid-cols-[minmax(0,1.25fr)_minmax(130px,.42fr)_minmax(210px,.72fr)_minmax(245px,.82fr)] lg:gap-10 lg:py-20">
        <div>
          <Link to="/" className="inline-block text-[clamp(2rem,3.2vw,3.25rem)] leading-none tracking-normal" data-testid="footer-logo" aria-label="Clube Digital, início">
            <strong className="font-extrabold">Clube</strong> <span className="font-normal">Digital</span>
          </Link>
          <p className="display-title mt-9 max-w-xl text-[clamp(2rem,3.4vw,4rem)] leading-[.97] text-white/92">
            Tecnologia que trabalha do seu jeito.
          </p>
          <p className="mt-7 max-w-md text-sm leading-relaxed text-white/40">Soluções digitais construídas ao redor da operação, das pessoas e dos objetivos de cada empresa.</p>
        </div>

        <nav aria-label="Links do rodapé">
          <p className="mb-6 text-[10px] font-bold uppercase tracking-[.2em] text-white/35">Navegação</p>
          <div className="flex flex-col items-start gap-3">
            {navigation.map((item) => (
              <Link
                key={item.to}
                to={item.to}
                className="text-sm text-white/65 transition-colors hover:text-lime-300 focus:outline-none focus-visible:text-lime-300"
              >
                {item.label}
              </Link>
            ))}
          </div>
        </nav>

        <nav aria-label="Soluções">
          <p className="mb-6 text-[10px] font-bold uppercase tracking-[.2em] text-white/35">Soluções</p>
          <div className="flex flex-col items-start gap-3">
            {SERVICES.map((service) => (
              <Link
                key={service.slug}
                to={`/servicos#${service.slug}`}
                className="text-sm text-white/65 transition-colors hover:text-lime-300 focus:outline-none focus-visible:text-lime-300"
              >
                {service.title}
              </Link>
            ))}
          </div>
        </nav>

        <div>
          <p className="mb-6 text-[10px] font-bold uppercase tracking-[.2em] text-white/35">Fale diretamente</p>
          <div className="flex flex-col items-start gap-4">
            <a
              href={getEmailLink()}
              className="group inline-flex items-center gap-2 text-sm text-white/75 transition-colors hover:text-lime-300 focus:outline-none focus-visible:text-lime-300"
              data-testid="footer-email"
            >
              {SITE.email}
              <ArrowUpRight className="transition-transform group-hover:-translate-y-0.5 group-hover:translate-x-0.5" size={15} />
            </a>
            <a
              href={getWhatsAppLink()}
              target="_blank"
              rel="noreferrer"
              className="group inline-flex items-center gap-2 text-sm text-white/75 transition-colors hover:text-lime-300 focus:outline-none focus-visible:text-lime-300"
              data-testid="footer-phone"
            >
              {SITE.phoneDisplay}
              <ArrowUpRight className="transition-transform group-hover:-translate-y-0.5 group-hover:translate-x-0.5" size={15} />
            </a>
          </div>
          <p className="mt-8 max-w-xs text-xs leading-relaxed text-white/35">Atendimento em todo o Brasil, com projetos pensados para a realidade de cada negócio.</p>
        </div>
      </div>

      <div className="flex flex-col gap-6 py-7 text-[10px] uppercase tracking-[.14em] text-white/30 sm:flex-row sm:items-center sm:justify-between">
        <div className="flex flex-col gap-2 sm:flex-row sm:gap-7">
          <p>© {new Date().getFullYear()} Clube Digital</p>
          <p>CNPJ {SITE.cnpj}</p>
        </div>
        <button
          type="button"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="group inline-flex w-fit items-center gap-3 text-white/45 transition-colors hover:text-white focus:outline-none focus-visible:text-lime-300"
          aria-label="Voltar ao topo da página"
        >
          Voltar ao topo
          <span className="grid size-9 place-items-center border border-white/15 transition-colors group-hover:border-white/40">
            <ArrowUp size={14} />
          </span>
        </button>
      </div>
    </div>
  </footer>
);
